import * as React from "react";
import { MessageCircle, Phone, Crosshair } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function JoinTheResistance() {
  return <section data-section-id="222297" id="get-your-custom-quote" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-background text-foreground py-24 sm:py-32 dark">
      {}
      <div className="absolute inset-0 z-0 opacity-20" style={{
      background: "radial-gradient(circle at center, var(--primary) 0%, transparent 60%)"
    }} />

      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none opacity-40">
        {}
        <div className="absolute size-[800px] rounded-lg border border-border/20" />
        <div className="absolute size-[600px] rounded-lg border border-border/30" />
        <div className="absolute size-[400px] rounded-lg border border-border/40" />
        <div className="absolute size-[200px] rounded-lg border border-border/50 bg-background/50 backdrop-blur-sm" />
        
        {}
        <Crosshair className="absolute size-8 text-primary/50" />

        {}
        <div className="absolute size-[800px] rounded-lg origin-center animate-spin" style={{
        animationDuration: "12s",
        animationTimingFunction: "linear",
        background: "conic-gradient(from 0deg, transparent 0deg, transparent 270deg, var(--primary) 360deg)",
        opacity: 0.2
      }} />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center flex flex-col items-center">
        <div className="inline-flex items-center rounded-lg border border-border/50 bg-card/50 px-3 py-1 text-sm font-mono text-primary backdrop-blur-md mb-8">
          <span className="flex size-2 rounded-lg bg-primary mr-2 animate-pulse"></span>
          Ottawa's Local Junk Experts
        </div>
        
        <h2 className="font-default text-5xl sm:text-7xl md:text-8xl font-bold tracking-tighter uppercase mb-6 drop-shadow-2xl text-transparent bg-clip-text bg-gradient-to-b from-foreground to-foreground/60">
          Get Your Free Quote in Minutes
        </h2>
        
        <p className="font-default text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
          No obligation, transparent pricing, and same-day service available across Ottawa, Kanata, Orleans, and Barrhaven. Text us photos for an instant estimate—we respond within 2 hours.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
          <Button asChild size="lg" variant="secondary" className="w-full sm:w-auto h-14 px-8 rounded-lg text-lg font-bold shadow-lg shadow-secondary/20 border-none hover:scale-105 transition-transform bg-secondary text-secondary-foreground">
            <Link to="#">
              <MessageCircle className="mr-2 size-5" />
              Text Us Photos
            </Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 rounded-lg text-lg font-bold bg-background/50 backdrop-blur-sm text-foreground hover:bg-accent shadow-lg hover:scale-105 transition-transform border-border/50">
            <Link to="/ServicesPage">
              <Phone className="mr-2 size-5" />
              Schedule Call
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}